import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src575184656/src/nuxt/layouts/default.vue").then(m => m.default || m))
}